export default {
  OPEN_LOAD_DETAILS: '@LOAD_DETAILS/OPEN_LOAD_DETAILS',
  CLEAR_LOAD_DETAILS: '@LOAD_DETAILS/CLEAR_LOAD_DETAILS',

  BID_ORDER: '@LOAD_DETAILS/BID_ORDER',
  BID_ORDER_SUCCESS: '@LOAD_DETAILS/BID_ORDER_SUCCESS',
  BID_ORDER_FAILURE: '@LOAD_DETAILS/BID_ORDER_FAILURE',

  BOOK_ORDER: '@LOAD_DETAILS/BOOK_ORDER',
  BOOK_ORDER_SUCCESS: '@LOAD_DETAILS/BOOK_ORDER_SUCCESS',
  BOOK_ORDER_FAILURE: '@LOAD_DETAILS/BOOK_ORDER_FAILURE',

  BID_OFFER: '@LOAD_DETAILS/BID_OFFER',
  BID_OFFER_SUCCESS: '@LOAD_DETAILS/BID_OFFER_SUCCESS',
  BID_OFFER_FAILURE: '@LOAD_DETAILS/BID_OFFER_FAILURE',

  BOOK_OFFER: '@LOAD_DETAILS/BOOK_OFFER',
  BOOK_OFFER_SUCCESS: '@LOAD_DETAILS/BOOK_OFFER_SUCCESS',
  BOOK_OFFER_FAILURE: '@LOAD_DETAILS/BOOK_OFFER_FAILURE',

  GET_MAP_IMAGE: '@LOAD_DETAILS/GET_MAP_IMAGE',
  GET_MAP_IMAGE_SUCCESS: '@LOAD_DETAILS/GET_MAP_IMAGE_SUCCESS',
  GET_MAP_IMAGE_FAILURE: '@LOAD_DETAILS/GET_MAP_IMAGE_FAILURE',

  GET_TRACTOR_DETAILS: '@LOAD_DETAILS/GET_TRACTOR_DETAILS',
  GET_TRACTOR_DETAILS_SUCCESS: '@LOAD_DETAILS/GET_TRACTOR_DETAILS_SUCCESS',
  GET_TRACTOR_DETAILS_FAILURE: '@LOAD_DETAILS/GET_TRACTOR_DETAILS_FAILURE'
}
